export const tr = {
    cancel: 'İptal',
    'no-creatives': 'Arşivlenen kreatif yok',
    view: 'Görüntüle'
};
